'use client'

import { useAudio } from '@/context/AudioContext'
import { useNavigation } from '@/context/NavigationContext'
import { Card, CardBody, Spinner } from '@heroui/react'
import { useEffect, useState } from 'react'
import Intro from './Intro'
import './landing.css'
import StartExperience from './StartExperience'

export default function Landing() {
  const { landingScreen } = useNavigation()
  const { audioIsReady } = useAudio()
  const [isLoading, setIsLoading] = useState(true)

  // Effect to react to the audioIsReady state change
  useEffect(() => {
    if (audioIsReady) {
      setIsLoading(false)
    }
  }, [audioIsReady])

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-screen cursor-default select-none loading-screen">
        <Card>
          <CardBody>
            <Spinner color="secondary" label="Nau mai haere mai" labelColor="secondary" size="lg" />
          </CardBody>
        </Card>
      </div>
    )
  }

  return (
    <>
      {landingScreen === 'splash' && <StartExperience />}
      {landingScreen === 'language' && <Intro />}
    </>
  )
}

export { Landing }
